// extracted by mini-css-extract-plugin
export default {"tabContent":"PRr6rQl2MC","tabContent_widthContrained":"kAFw1EHtrS","moreInfoAnchor":"ouErGBYsfz"};